import { createElement } from "react";
import { toast } from "react-toastify";

const baseStyle = {
  background: "#fff",
  color: "#1c1c1c",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
  fontSize: "14px",
  fontWeight: 500,
  padding: "12px 18px",
  minWidth: "260px",
};

const iconWrap = (bg, svgPath) =>
  createElement(
    "span",
    {
      style: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 22,
        height: 22,
        borderRadius: "50%",
        background: bg,
        flexShrink: 0,
      },
    },
    createElement(
      "svg",
      { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none" },
      createElement("path", {
        d: svgPath,
        stroke: "#fff",
        strokeWidth: 1.8,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }),
    ),
  );

const base = {
  position: "top-center",
  autoClose: 3500,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  style: baseStyle,
};

const appToast = {
  success: (msg) =>
    toast.success(msg, {
      ...base,
      icon: () => iconWrap("#22c55e", "M2 6l3 3 5-5"),
    }),

  error: (msg) =>
    toast.error(msg, {
      ...base,
      icon: () => iconWrap("#ef4444", "M2 2l6 6M8 2l-6 6"),
    }),

  warning: (msg) =>
    toast.warning(msg, {
      ...base,
      icon: () => iconWrap("#f59e0b", "M6 2v4M6 9v0.5"),
    }),
};

export default appToast;
